// Footer.js
import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { Facebook, Instagram, Twitter, YouTube } from '@mui/icons-material';
import { trackContact } from '../utils/supabaseEdgeApi';

const Footer = () => {

    return (
        <Box sx={{ backgroundColor: '#333', color: 'white', padding: '30px 0' }}>
            <Container>
                <Grid container spacing={3} justifyContent="space-between">
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Vedamarga
                        </Typography>
                        <Typography variant="body2" color="white" sx={{ marginTop: '10px' }}>
                            Your one-stop solution for all types of pooja services.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Quick Links
                        </Typography>
                        <Link href="/" color="inherit" sx={{ display: 'block', marginTop: '10px' }}>
                            Home
                        </Link>
                        <Link href="tel:+919986144114" onClick={() => trackContact('call')} color="inherit" sx={{ display: 'block', marginTop: '10px' }}>
                            Contact
                        </Link>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Follow Us
                        </Typography>
                        <Box sx={{ marginTop: '10px' }}>
                        <Link href={process.env.REACT_APP_FACEBOOK} color="inherit" sx={{ marginRight: '10px' }}>
    <Facebook />
</Link>
                            <Link href={process.env.REACT_APP_INSTAGRAM} color="inherit" sx={{ marginRight: '10px' }}>
                                <Instagram />
                            </Link>
                            <Link href={process.env.REACT_APP_YOUTUBE} color="inherit">
                                <YouTube />
                            </Link>
                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="white" sx={{ textAlign: 'center', marginTop: '30px' }}>
                    &copy; 2024 Vedamarga. All Rights Reserved.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
